import styles from "./styles.module.scss";

const OptionCard = ({ option }) => {
    return (
      <div
        className={`${styles.item} ${styles.optionItem} ${
          option.disabled ? styles.disabled : ""
        }`}
      >
        <img
          alt="option"
          className={styles.image}
          src={option.image_url.replace(/\\\//g, "/")}
        />
        <div className={styles.content}>
          <h4 className={styles.optionTitle} style={{ color: option.color }}>
            {option.name}
          </h4>
          <span className={styles.description}>{option.description}</span>
        </div>
      </div>
    );
  };

  
  export default OptionCard;